import { Language, TemplateSubType, TemplateType } from '../../../types/dto-app';

export const leasePaymentReceiptTemplates = [
  {
    id: '-119001',
    language: Language.EN,
    subject: 'Your lease has been paid',
    type: TemplateType.MAIL,
    subType: TemplateSubType.LEASE_PAYMENT_RECEIPT,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Dear {{listAllTenants lease}},</p>
        <p></p>
        <p>I confirm receipt of payment for the lease located at <strong>{{getLeaseMainAddress lease}}</strong>.</p>
        <p>You will find the receipt attached to this email.</p>
        <p></p>
        <p>Kind regards,</p>
        <p></p>
        <p>{{accountSignature client}}</p>
        `,
  },
  {
    id: '-119002',
    language: Language.FR,
    subject: 'Votre bail a été payé',
    type: TemplateType.MAIL,
    subType: TemplateSubType.LEASE_PAYMENT_RECEIPT,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Cher/Chère {{listAllTenants lease}},</p>
        <p></p>
        <p>Je vous confirme la bonne réception du paiement du bail sis <strong>{{getLeaseMainAddress lease}}</strong>.</p>
        <p>Vous trouverez la quittance en pièce jointe de ce mail.</p>
        <p></p>
        <p>Bien à vous,</p>
        <p></p>
        <p>{{accountSignature client}}</p>
        `,
  },
  {
    id: '-119003',
    language: Language.NL,
    subject: 'Uw huurcontract is betaald',
    type: TemplateType.MAIL,
    subType: TemplateSubType.LEASE_PAYMENT_RECEIPT,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Geachte {{listAllTenants lease}},</p>
        <p></p>
        <p>Ik bevestig de ontvangst van de betaling voor het huurcontract gelegen op <strong>{{getLeaseMainAddress lease}}</strong>.</p>
        <p>U vindt het ontvangstbewijs als bijlage bij deze e-mail.</p>
        <p></p>
        <p>Met vriendelijke groeten,</p>
        <p></p>
        <p>{{accountSignature client}}</p>
        `,
  },
  {
    id: '-119004',
    language: Language.DE,
    subject: 'Ihr Mietvertrag wurde bezahlt',
    type: TemplateType.MAIL,
    subType: TemplateSubType.LEASE_PAYMENT_RECEIPT,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Liebe/r {{listAllTenants lease}},</p>
        <p></p>
        <p>Ich bestätige den Erhalt der Zahlung für den Mietvertrag in <strong>{{getLeaseMainAddress lease}}</strong>.</p>
        <p>Sie finden die Quittung als Anhang zu dieser E-Mail.</p>
        <p></p>
        <p>Mit freundlichen Grüßen,</p>
        <p></p>
        <p>{{accountSignature client}}</p>
        `,
  },
];
